import React from 'react';
import { connect } from 'react-redux';
import { useTranslation, Trans } from 'react-i18next';
import { getOnboardingState, getTenantState } from '../../../store/selectors';
import AddToTopCareersButton from './careers/AddToTopCareersButton';
import CareerOneStop from '../api/onestop/CareerOneStop';
import ModalMath from './degrees/ModalMath';
import DegreeModalInfo from './degrees/DegreeModalInfo';
import CareerDescription from './careers/CareerDescription';
import DegreeDescription from './degrees/DegreeDescription';
import DegreeReq from './degrees/DegreeReq';
import EarningCapacity from './careers/EarningCapacity';
import Skills from './careers/Skills';

export const sectionClassMapping = {
  Favorites: 'favorites',
  'Top 25': 'top-25',
  'All Careers': 'all-careers',
  'Searching Careers...': 'all-careers-search',
};

function _ModalCompare(props) {
  const { t } = useTranslation();
  const {
    degree,
    career,
    title,
    isTopCareer,
    transferable,
    checkDegreeIcons,
    description,
    requirements,
    handleAddCareer,
    careerInfoLoading,
    degreeInformation,
    displayList,
    listAvailableLocations,
    modalNumber,
    location,
  } = {
    ...props,
  };

  const showSkillsSection = () => {
    if (degree) return;
    return <Skills career={career} carouselClassName="margin-right-offset" />;
  };

  /* eslint-disable react/jsx-one-expression-per-line */
  /* Note: the above eslint-disable is necessary as the interpolation within <Trans> components is wrongly interpreted as JSX */

  /* eslint-disable react/jsx-indent */
  return (
    <div
      id={`modal-compare-${modalNumber}`}
      className="career-content"
      data-cy="modal-career-content"
    >
      <h2 id="header" data-cy="modal-header" className="modal-degree-type-en">
        {title}
        {degree ? checkDegreeIcons(degree) : null}
      </h2>
      {career &&
      !isTopCareer(career.id) &&
      career.degree &&
      !location.pathname.includes('user-profile') ? (
        <AddToTopCareersButton
          tenant={props.tenant}
          addCareer={() => handleAddCareer(career)}
        />
      ) : null}
      {(career &&
        props.onboarding.userData &&
        props.onboarding.userData.user.country) === 'United States' &&
      props.tenant.name !== 'Baobab' ? (
        <CareerOneStop
          tenant={props.tenant}
          career={career}
          careerInfoLoading={careerInfoLoading}
          modalStyling
        />
      ) : null}
      {career && props.tenant.name === 'Baobab' && (
        <EarningCapacity tenant={props.tenant} career={career} />
      )}
      {degree && degreeInformation ? (
        <>
          {degree.mathIntensity && degree.firstMathReq ? (
            <ModalMath degree={degree} tenant={props.tenant} />
          ) : null}
          <DegreeModalInfo tenant={props.tenant} />
        </>
      ) : null}
      {career ? (
        <CareerDescription career={career} description={description} />
      ) : null}
      {degree ? (
        <>
          {degree.mathIntensity && degree.firstMathReq ? (
            <ModalMath degree={degree} tenant={props.tenant} />
          ) : null}
          <DegreeDescription
            career={career}
            description={description}
            transferable={transferable}
          />
        </>
      ) : null}
      {degree && requirements && <DegreeReq requirements={requirements} />}
      {career && career.tasks !== null ? (
        <>{displayList(career.tasks)}</>
      ) : null}
      {!!degree && !!degree.institution_info && props.tenant.name !== 'Baobab' && (
        <div className="last-element-padding">
          <p className="bold grey locations-header">{t('Learn More: ')}</p>
          {listAvailableLocations(degree.institution_info)}
        </div>
      )}
      {!!degree && !!degree.institution_info && props.tenant.name === 'Baobab' && (
        <div className="last-element-padding">
          <p className="bold grey locations-header">{t('Learn More: ')}</p>
          <a
            href="https://sites.google.com/baobabplatform.org/meet-the-baobab-ambassadors/me3"
            className="available-location"
            target="_blank"
            rel="noreferrer noopener"
          >
            {t('Explore degree options')}
          </a>
        </div>
      )}
      {showSkillsSection()}
      {career && (
        <div>
          <p className="onet-citation">
            <Trans>
              This page includes information from the{' '}
              <a
                href="https://www.onetcenter.org/database.html"
                target="_blank"
                rel="noreferrer noopener"
              >
                {{ databaseName: 'O*NET 25.2' }}
              </a>{' '}
              Database by the U.S. Department of Labor, Employment and Training
              Administration (USDOL/ETA). Used under the{' '}
              <a
                href="https://creativecommons.org/licenses/by/4.0/"
                target="_blank"
                rel="noreferrer noopener"
              >
                {{ licenseName: 'CC BY 4.0' }}
              </a>{' '}
              license. {{ databaseName: 'O*NET®' }} is a trademark of USDOL/ETA.
              Arizona State University has modified all or some of this
              information. USDOL/ETA has not approved, endorsed, or tested these
              modifications.
            </Trans>
          </p>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  const onboarding = getOnboardingState(state);
  const tenant = getTenantState(state);

  return { onboarding, tenant };
};

export const ModalCompare = connect(mapStateToProps, {})(_ModalCompare);
